export const CONTACT_SUBJECTS = [
  'General Inquiry',
  'Technical Support',
  'Practitioner Interest',
  'Partnership',
  'Media',
] as const;

export type ContactSubjectT = typeof CONTACT_SUBJECTS[number];

export const ERR_CODE_ALREADY_PRACTITIONER = 1001;

export const KB_BYTES = 1024;
export const MB_BYTES = 1024 * KB_BYTES;
export const GB_BYTES = 1024 * MB_BYTES;

export const GS_SCHEMA = 'gs://';

export const MAX_AUDIO_SIZE = 100 * MB_BYTES;
export const MAX_DOCUMENT_SIZE = 50 * MB_BYTES;
export const MAX_IMAGE_SIZE = 25 * MB_BYTES;

// NOTE: 300GB is the maximum video size Vimeo allows, as per:
// https://developer.vimeo.com/api/upload/videos
export const MAX_VIDEO_SIZE = 4 * GB_BYTES;

// Hostname / domain of the production deployment (current use - we only want
// to add GA scripts, and enable GA when the app is accessed on that domain).
export const PROD_HOSTNAME = 'mysoulsanctuary.net';

export type PreferredResponseMethodT = 'Email' | 'Phone';
